import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { toNumber } from 'lodash';
import React from 'react';
import { BooleanParam, useQueryParam } from 'use-query-params';

import { MainPageAnnotationDrawer } from 'components/AssignmentsList/MainPageAnnotationDrawer';
import { TableEditingContextProvider } from 'components/atoms/EditableDataGrid/TableEditingContext';
import { RowSelectionContextProvider } from 'components/atoms/RowSelectionContext';
import CantAccessStudy from 'components/CantAccessStudy';
import useMainFilters from 'components/SearchFilters/hooks/useMainFilters';
import SiteHeader from 'components/SiteHeader/SiteHeader';
import { useProceduresFieldsContext } from 'interfaces/procedure/fields/helpers';
import { useEncodedFilters } from 'utils/useEncodedFilters';
import useStudy from 'utils/useStudy';
import { MultiplexWorkflowProvider } from './Pipelines/Multiplex/MultiplexWorkflowContext';
import StudyDashboardBody from './StudyDashboardBody';

const StudyDashboard: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const { queryParams } = useEncodedFilters();

  const { isStudyIdSpecific } = useMainFilters();

  const specificStudySelected = isStudyIdSpecific(queryParams.filters?.studyId);

  const { isForbidden, study } = useStudy(queryParams.filters?.studyId, {
    enabled: specificStudySelected,
  });

  const [slidesMode] = useQueryParam('slidesMode', BooleanParam);

  const proceduresFieldsContext = useProceduresFieldsContext();

  if (isForbidden) {
    return <CantAccessStudy />;
  }

  return (
    <RowSelectionContextProvider
      urlParamPrefix="studyDashboard"
      convertIdFromString={!slidesMode ? toNumber : undefined}
    >
      <TableEditingContextProvider fieldsContext={proceduresFieldsContext}>
        <MultiplexWorkflowProvider key={queryParams.filters?.studyId || 'no-study'} study={study}>
          <StaticPage>
            <SiteHeader />
            <StudyDashboardBody />
            <MainPageAnnotationDrawer />
          </StaticPage>
        </MultiplexWorkflowProvider>
      </TableEditingContextProvider>
    </RowSelectionContextProvider>
  );
};

export default StudyDashboard;

const StaticPage = styled(Box)(() => ({
  overflow: 'hidden',
}));
